module.exports = __webpack_public_path__ + "static/media/newretail_bg.e22927f4.png";